<template>
  <div class="home">
<div class="works-ban">
	
		<p> 
<span class="acts">購物車 </span>  →   <span>結帳</span>  →  <span>訂單完成</span>  </p>
	</div>
   <div class="home-ct">
	   <div class="cart-alt">
	   <el-row gutter="20">
		<el-col span="17">
			   <div class="cart">
			   		<div>
			   			<el-row class="cart-tit">
							<el-col span="12">產品</el-col>
							<el-col span="6">數量</el-col>
							<el-col span="6">總計</el-col>
						</el-row>
			   		
			   					</div>
			   					<div>
			   						<ul>
			   							<li v-for="item in roll" class="cart-con">
											<el-row>
												<el-col span="1">
													<img @click="bit(item)" src="../../assets/arr.png" />
													</el-col>
													<el-col span="4">
															<img class="cart-img" :src="item.image" />
														</el-col>
														<el-col span="7" class="cart-t1">
															<b>{{item.title}}</b>
															</el-col>
												<el-col span="6"> <el-input-number size="mini"  v-model="item.num" @change="handleChange(item.num,item.inventoryId)" :min="1" :max="10" ></el-input-number></el-col>
												<el-col span="6">￥ {{item.num*item.price_sale}}</el-col>
											</el-row>
			   							
											
			   							</li>
										
			   						
			   					</ul>
			   					</div>
			   					
			   					<div class="cart-bot">
			   					
			   						<div class="l1">
			   						
			   							<router-link to="/product/list"><div class="h-button shop">繼續購物</div></router-link>
										<div class="h-button shop">更新購物車</div>
			   						</div>
			   					</div>
			   		   
			   </div>
		   
		 </el-col>
		 <el-col span="7" v-if="pull">
			 
			 <div class="login-r2">
			
			 
			 	<div class="ord-cart" >
			 			<div class="cart-tit">
			 				<h4>購物車總數</h4>
			 				
			 						</div>
			 						
			 						<div class="cart-bot">
			 							<div class="l1">
			 								<h4>小計</h4>
			 								<h4>￥ {{price}}</h4>
			 							</div>
										<div class="l1">
											<h4>入場券</h4>
											<h4>{{buff.voucher_num}} 可獲得的</h4>
										</div>
			 							<div class="l1" @click="full">
			 								<h4>購物券</h4>
			 								<h4>￥ {{coupon||0}}<span>></span></h4>
			 							</div>
			 							<div class="l4" v-if="feed">
			 								<p v-for="item in buff.yhq_list"><span>￥{{item.jian}} {{item.title}} </span>
											<el-button size="mini" v-if="kid" @click="coupons(item)" round>使用</el-button>
										
											</p>
			 							</div>
			 							<div class="l1" v-if="buff.jifen_pay.if_open==1">
			 								<h4>你可以用 {{buff.jifen_pay.jifen}}積分抵扣 {{buff.jifen_pay.money}} </h4>
			 							<div v-if="sandy" @click="holl(false)"> <img src="../../assets/fid.png"></div><div v-else @click="holl(true)"> <img src="../../assets/fid2.png"></div>
			 							</div>
			 							<div class="l1">
			 								<h4>運費</h4>
			 								<h4>CN ¥ {{buff.yunfei||0}}</h4>
			 							</div>
			 							<div class="l3">
			 								<h4>總計</h4>
			 								<h4>{{total}}</h4>
			 								
			 							</div>
			 						
			 						</div>
			 							
			 			   
			 	</div>
			 	
			
			 <router-link :to="'/product/order?yhq='+this.yhq+'&sandy='+this.sandy+'&ic='+this.ic"><div class="h-button">下單</div></router-link>
			 
			 </div>
			 
		 </el-col>
	   </el-row>
	</div>
	
   </div>
    </div>
</template>
<script>


export default {

  data() {
    return {
		
		id:'',
		images:[
		'https://img.yzcdn.cn/vant/apple-2.jpg',
		'https://img.yzcdn.cn/vant/apple-2.jpg',
		],
		ride:0,
		num: 1,
		info:'',
		news:[],
		notice:[],
		cart:false,
		ic:0,
		price:0,
		roll:'',
		total:0,
		price:0,
		buff:'',
		coupon:0,
		yhq:'',
		product_info:[],
		kid:true,
		feed:false,
		sandy:false,
		pull:true
		
    
    };
  },  mounted() {
	  
	  this.id = this.$route.query.id;
	
		this.sandMate();
	
		this.sandCart();
		},methods: {
			
			carou(e){
				this.ride=e
			},
			full(){
				this.feed=true
			},
			nood(index){
				this.$refs.carousel.setActiveItem(index)
			},
			holl(pic){
				this.sandy=pic
				if(this.sandy){
					this.total=this.price-this.coupon+this.buff.yunfei-this.buff.jifen_pay.money
					this.total=Number(this.total).toFixed(2)
				}else{
					this.total=this.price-this.coupon+this.buff.yunfei
					this.total=Number(this.total).toFixed(2)
				}
			},
		handleChange(num,inventoryId){
			this.$axios({
			  method: "post",
			  url: "service.php?action=gouwuche_updateNum",
			  data: {inventoryId:inventoryId,num:num},  
			}).then((res) => {
				let data=res.data;
			
				if(data.code==1){
					this.sandMate();
				
					this.sandCart()
				}else{
					this.$message.error(data.message);
				}
			 
			});
		}, coupons(item){
		 if(this.kid){
				this.yhq=item.id;
				this.ic=item.yhqId
				this.coupon=item.jian;
				if(this.sandy){
					this.total=this.price-this.coupon+this.buff.yunfei-this.buff.jifen_pay.money
					this.total=Number(this.total).toFixed(2)
				}else{
					this.total=this.price-this.coupon+this.buff.yunfei
					this.total=Number(this.total).toFixed(2)
				}
						
				 this.feed=false
				}
			
			  },sandMate(){
				this.$axios({
				  method: "post",
				  url: "service.php?action=product_detail",
				  data: {inventoryId:this.id},  
				}).then((res) => {
					let data=res.data;
				
					if(data.code==1){
						this.news=data.data;
					}
				 
				});
			
			},  sandCase(){
			
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=orders_getPayInfo",
			  	  data: {product_info:JSON.stringify(this.product_info)},  
			  	}).then((res) => {
			  		let data=res.data;
			  
			  		if(data.code==1){
			  					
			  			this.buff=data.data;
						if(this.sandy){
							this.total=this.price-this.coupon+this.buff.yunfei-this.buff.jifen_pay.money
							this.total=Number(this.total).toFixed(2)
						}else{
							this.total=this.price-this.coupon+this.buff.yunfei
							this.total=Number(this.total).toFixed(2)
						}
						
					
			  		
			  		}else{
						this.pull=false
						this.$message.error(data.message);
					}
			  	 
			  	});
			  
			  },collect(it){
			
							if(window.localStorage.getItem('user')== "undefined"){
								  this.$router.push({ path: "/login" });	
								return
							}
							this.$axios({
							  method: "post",
							  url: "service.php?action=product_collect",
							  data: {inventoryId:this.id,collect_type:it},  
							}).then((res) => {
								let data=res.data;
								
								if(data.code==1){
									this.$message.success(data.message);
									this.sandMate();
								
								}else{
									this.$message.error(data.message);
								}
							 
							});
						},sandCart(){
				this.price=0;
				this.$axios({
				  method: "post",
				  url: "service.php?action=gouwuche_lists",
				  data: {},  
				}).then((res) => {
					let data=res.data;
					
					
					if(data.code==1){
						this.roll=data.data;
						this.product_info=[]
						this.roll.forEach((item, index) => {
						
						
							this.price =this.price+item.price_sale * item.num
							
							this.product_info.push({
									"inventoryId": item.inventoryId,
									"productId": item.productId,
									"num": item.num
								})
							
								this.sandCase();
							
						})
						
					}
				 
				});
			},sandYart(){
				if(window.localStorage.getItem('user')== "undefined"){
					  this.$router.push({ path: "/login" });	
					return
				}
				this.$axios({
				  method: "post",
				  url: "service.php?action=gouwuche_add",
				  data: {inventoryId:this.news.inventoryId,num:this.num},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==1){
						this.$message.success(data.message);
						  this.cart=true;
						this.sandCart()
					}else{
						this.$message.error(data.message);
					}
				 
				});
			},bit(item){
				
				this.$axios({
				  method: "post",
				  url: "service.php?action=gouwuche_del",
				  data: {inventoryId:item.inventoryId},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==1){
						this.$message.success(data.message);
						this.sandMate();
						this.sandCase();
						this.sandCart()
					}else{
						this.$message.error(data.message);
					}
				 
				});
			}
		}
};
</script>
<style lang="scss" scoped>
.cart-alt{
	margin: 40px 0;
}
	.ord-cart{
		margin-bottom: 20px;
		background: #FFFFFF;
	
		border: 1px solid #eeeeee;
		.cart-tit{
			
			height:70px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 20px;
			border-bottom: 1px solid #eeeeee;
			img{
				width: 11px;
				height: 10px;
			}
			h4{
			
				font-size: 22px;
				font-family: Arial;
				font-weight: bold;
				color: #2D2A2A;
				line-height: 40px;
				

			}
		}
		.cart-but{
			
			margin-top: 20px;
		}
		.cart-con{
			margin-bottom: 100px;
			li{
				padding: 20px;
				display: flex;
				border-bottom: 1px solid #eeeeee;
				justify-content: space-between;
				.pic{
					width: 115px;
					height: 77px;
					img{
						width: 100%;
						height: 100%;
					}
				}
				.txt{
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					margin-left: 10px;
					
				}
				.lt{
					display: flex;
				}
				
				
			}
		}
		.cart-bot{
			font-size: 14px;
			padding: 20px;
			border-top: 1px solid #eeeeee;
			.l1{
				display: flex;
				line-height: 50px;
				justify-content: space-between;
				border-bottom: 1px solid #eeeeee;
				span{
					font-weight: normal;
					margin-left: 10px;
				}
			}
			
			.l2{
				display: flex;
				
			}
			.l3{
				font-size: 24px;
				display: flex;
				line-height: 50px;
				justify-content: space-between;
			
			}
			.l4{
				p{
				
					display: flex;
					height: 50px;
					justify-content: space-between;
					align-items: center;
					border-bottom: 1px dotted #DDDDDD;
					padding: 0 20px;
				}
				
			}
		}
		.ord-cir{
			display: flex;
			padding: 20px;
			line-height: 50px;
			align-items: center;
			.p1{
				width: 13px;
				height: 13px;
				margin-right: 10px;
			}
			.p2{
				width: 65px;
				height: 18px;
				margin-left: 10px;
			}
		}
	}

	.login{
		padding: 20px 0;
		.re-tit{
			line-height: 50px;
			h4{
				font-size: 26px;
			}
			margin-bottom: 20px;
		}
	}	
	.h-button{
		text-align: center;
		cursor: pointer;	
		padding: 0 50px;
		height: 50px;
		line-height: 50px;
		background: #000;
		color: #FFFFFF;
		
	}
	.h-button:hover{
		background-color: #333333;
	}
	.cart{
	
		background: #FFFFFF;
		.cart-tit{
			height: 70px;
			line-height: 70px;
			text-align: center;
			font-size: 16px;
			font-family: Arial;
			font-weight: bold;
			color: #0A0A0A;
			border-bottom: 1px solid #eeeeee;
			margin-bottom: 20px;
		}
		.cart-con{
			font-size: 14px;
			 line-height: 100px;
			 text-align: center;
			 .cart-t1{
				 line-height: 30px;
			 }
		}
		.cart-but{
			margin-top: 20px;
		}
		.cart-img{
			width: 100%;
		}
		.cart-bot{
		
			padding: 20px;
			border-top: 1px solid #eeeeee;
			.l1{
				display: flex;
				justify-content: space-between;
			}
		}
	}
	.el-carousel__item h3 {
	    color: #475669;
	    font-size: 14px;
	    opacity: 0.75;
	    line-height: 150px;
	    margin: 0;
	  }
	
	  .el-carousel__item:nth-child(2n) {
	     background-color: #99a9bf;
	  }
	  
	  .el-carousel__item:nth-child(2n+1) {
	     background-color: #d3dce6;
	  }
	.works-ban{
		font-family: 'Arial-BoldMT';
		padding-top: 15px;
		background: #0A0A0A;
		height: 57px;
		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
		h2{
			font-size: 43px;
		}
		span{
			margin: 20px;
			color: #B5B5B5;
		}
		.acts{
			color: #FFFFFF;
			font-weight: bolder;
		}
	}
</style>